import React, { useEffect, useState } from 'react';
import { DefaultLayout } from '../layout/DefaultLayout';
import './Accounts.scss';
import { packageName } from '../package';
import { Server } from 'lincd-server-utils/lib/utils/Server';
import { ShapeSet } from 'lincd/lib/collections/ShapeSet';
import { ImageObject } from 'lincd-schema/lib/shapes/ImageObject';

export default function MediaManagement() {
  const [images, setImages] = useState<ShapeSet<ImageObject> | null>(null);
  const [editingUrlId, setEditingUrlId] = useState<string | null>(null);
  const [currentEditUrl, setCurrentEditUrl] = useState<string>('');

  useEffect(() => {
    // Fetch images from the server on mount
    Server.call(packageName, 'getAllMedia').then((fetchedImages) => {
      setImages(fetchedImages);
    });
  }, []);

  // Group images by 'creditText'
  const groupImagesByCreditText = (images: ShapeSet<ImageObject>) => {
    return images.reduce((groups, image) => {
      const { creditText } = image;
      if (!groups[creditText]) {
        groups[creditText] = [];
      }
      groups[creditText].push(image);
      return groups;
    }, {} as Record<string, ImageObject[]>);
  };

  const handleQuoraUrlClick = (image: ImageObject) => {
    setEditingUrlId(image.uri);
    setCurrentEditUrl(image.url || '');
  };

  const handleUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentEditUrl(event.target.value);
  };

  const handleUrlBlur = async (image: ImageObject) => {
    if (currentEditUrl === image.url) {
      setEditingUrlId(null);
      return;
    }
    image.url = currentEditUrl;
    setEditingUrlId(null);
  };

  const removeImage = async (image: ImageObject) => {
    if (!window.confirm(`Are you sure you want to delete the image "${image.name}"?`)) {
      return;
    }
    image.remove();
    setImages(images.filter((img) => img.uri !== image.uri));
  };

  if (!images) {
    return <p>Loading...</p>;
  }

  const groupedImages = groupImagesByCreditText(images);

  return (
    <DefaultLayout>
      <div style={{ padding: '1rem' }}>
        <h1>Media</h1>
        {Object.entries(groupedImages).map(([creditText, imageGroup], index) => (
          <div
            key={creditText}
            style={{
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#eef2f7',
              marginBottom: '2rem',
              padding: '1rem',
              borderRadius: '5px',
            }}
          >
            <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>
              {creditText || 'Unknown Credit'}
            </h2>
            <hr style={{ border: '0.5px solid #ccc', marginBottom: '1rem' }} />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              {imageGroup.map((image) => (
                <div
                  key={image.uri || image.contentUrl}
                  style={{
                    maxWidth: '15vw',
                    display: 'inline-block',
                    overflow: 'hidden',
                    margin: '0.5rem',
                  }}
                >
                  <h3 style={{ fontSize: '1.2rem' }}>{image.name}</h3>
                  <a href={image.contentUrl} download={image.name || 'download'} target="_blank" rel="noopener noreferrer">
                    <img
                      src={image.contentUrl}
                      alt={image.name || 'Downloadable media'}
                      style={{ cursor: 'pointer', maxWidth: '200px', height: 'auto' }}
                    />
                  </a>
                  {/*<p>Digital Ocean URL: {image.contentUrl}</p>*/}
                  <p>Usage Info: {image.usageInfo}</p>
                  <p>Date Created: {image.dateCreated}</p>
                  {/*<p>Copyright Notice: {image.copyrightNotice}</p>*/}
                  <p>
                    Quora URL:{' '}
                    {editingUrlId === image.uri ? (
                      <input
                        type="text"
                        value={currentEditUrl}
                        onChange={handleUrlChange}
                        onBlur={() => handleUrlBlur(image)}
                        autoFocus
                        style={{ marginLeft: '5px' }}
                      />
                    ) : (
                      <span
                        onClick={() => handleQuoraUrlClick(image)}
                        style={{
                          cursor: 'pointer',
                          textDecoration: 'underline',
                          color: 'blue',
                          marginLeft: '5px',
                        }}
                      >
                        {image.url || '[Click to add URL]'}
                      </span>
                    )}
                  </p>
                  <p>
                    <a href="#" onClick={removeImage.bind(null, image)}>❌</a>
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </DefaultLayout>
  );
}